var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vmap",attrs:{"id":"vmap"}},[_c('el-amap',{staticClass:"amap-demo",attrs:{"vid":"amap","center":_vm.center,"zoom":_vm.zoom,"scroll-wheel":false,"drag-enable":false,"map-style":"dark"}}),_c('div',{staticClass:"mask"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }